module.exports = __webpack_public_path__ + "img/shang@3x.85c843a2.png";